(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["willowglow-product"]) return;
  try {
    
(function () {
  var dataEl = document.getElementById('wg-variant-data');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var variants = data.variants;

  var state = { bundle: 'Single', style: 'Complete Kit' };

  var bundleCards = document.querySelectorAll('.wg-bundle-card');
  var styleCards = document.querySelectorAll('.wg-style-card');
  var addonInputs = document.querySelectorAll('.wg-addon input');
  var priceEl = document.getElementById('wg-price');
  var compareEl = document.getElementById('wg-compare-price');
  var saveBadgeEl = document.getElementById('wg-save-badge');
  var saveLineEl = document.getElementById('wg-save-line');
  var totalEl = document.getElementById('wg-total-price');
  var addToCartBtn = document.getElementById('wg-add-to-cart');
  var errorEl = document.getElementById('wg-cart-error');

  function findVariant() {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].bundle === state.bundle && variants[i].style === state.style) return variants[i];
    }
    return null;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function render() {
    var v = findVariant();
    if (!v) return;
    var price = parseFloat(v.price);
    var compare = v.compareAtPrice ? parseFloat(v.compareAtPrice) : null;

    priceEl.textContent = money(price);
    if (compare && compare > price) {
      compareEl.textContent = money(compare);
      compareEl.style.display = '';
      var pct = Math.round((1 - price / compare) * 100);
      saveBadgeEl.textContent = pct + '% OFF';
      saveBadgeEl.style.display = '';
      saveLineEl.textContent = 'You save ' + money(compare - price);
      saveLineEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
      saveBadgeEl.style.display = 'none';
      saveLineEl.style.display = 'none';
    }

    var total = price;
    addonInputs.forEach(function (input) {
      if (input.checked) total += parseFloat(input.dataset.addonPrice) * 100;
    });
    totalEl.textContent = money(total);
  }

  bundleCards.forEach(function (card) {
    card.addEventListener('click', function () {
      bundleCards.forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
      state.bundle = card.dataset.bundle;
      render();
    });
  });

  styleCards.forEach(function (card) {
    card.addEventListener('click', function () {
      styleCards.forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
      state.style = card.dataset.style;
      render();
    });
  });

  addonInputs.forEach(function (input) {
    input.addEventListener('change', render);
  });

  var thumbs = document.querySelectorAll('.wg-thumb');
  var mainImg = document.getElementById('wg-main-img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.dataset.full;
    });
  });

  addToCartBtn.addEventListener('click', function (e) {
    e.preventDefault();
    errorEl.style.display = 'none';
    var v = findVariant();
    if (!v) { errorEl.textContent = 'Please choose an option.'; errorEl.style.display = ''; return; }

    var items = [{ id: v.id, quantity: 1 }];
    addonInputs.forEach(function (input) {
      if (input.checked && input.dataset.addonId) {
        items.push({ id: parseInt(input.dataset.addonId, 10), quantity: 1 });
      }
    });

    addToCartBtn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart'); });
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        errorEl.textContent = err.message;
        errorEl.style.display = '';
        addToCartBtn.textContent = 'Add to Cart — ' + totalEl.textContent;
      });
  });

  render();
})();

  } catch(e) { console.error(e); }
})();
})();
